var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkflowhugeIcon = function SvgWorkflowhugeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 77 75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8D76FF",
    d: "M38.595 5.957 30.34 20.174h16.472L38.595 5.957ZM75 69.044 47.078 20.629v7.28H30.036v-7.204L2 68.892h15.673v-7.127h41.73v7.24H75v.039Zm-47.399-39.05H49.4v7.734H27.6v-7.734Zm-3.157 10.388h28.15v8.037h-28.15v-8.037ZM56.55 59.224H20.488v-8.227h36.1v8.227h-.038Z"
  })));
};
export default SvgWorkflowhugeIcon;